<template>
    <div>
        <gofix-card class="mb-0" fullContent>
            <!-- @new-email-item="addEmailActivityLog"                                  
            @delete-items="deleteItems"
            -->
            <gofix-default-table class=""
                                 :settings="tableConfig"
                                 :table-items="tableItems"
                                 @load-items="getTableData"
                                 @new-item="addActivityLog"
                                 @reply-item="replyItem"
                                 @row-click="clickToRowItem"
                                 @export="exportNLT"
                                 @change-selected="changeSelectedTable"
                                 @resend-email="resendEmail"
                                 ref="gofixTable" :key="render">
                <template slot="gofix_table:after-control-left" slot-scope="row">
                    <gofix-form-dropdown
                        style="width:auto"
                        class="highlightDropdown ml-2 mr-3"
                        label=""
                        :clearable="false"
                        :searchable="false"
                        placeholder="Show"
                        @change="filterList"
                        :options="optionFilter"
                        :reduce="option => option.value"
                        v-model="isFilterDrp">
                    </gofix-form-dropdown>
                </template>
                <template slot="gofix_table:time_stamp" slot-scope="row">
                    {{row.item.time_stamp | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                </template>
                <template slot="gofix_table:email_call_time" slot-scope="row">
                    {{row.item.email_call_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                </template>
                <template slot="gofix_table:created_at" slot-scope="row">
                    {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                </template>
                <template slot="gofix_table:remark" slot-scope="row">
                    <div v-if="checkIsJson(row.item.remark)">
                        <json-viewer
                                :value="row.item.remark | isJson"
                                :expand-depth="0"
                                sort></json-viewer>
                    </div>
                    <div style="white-space: pre-line;" v-else v-html="row.item.remark"></div>
                </template>
                <template slot="gofix_table:case_log_attachments" slot-scope="row">
                    <div v-if="row.item.attachments !== null && row.item.attachments.length > 0" class="attachmentsColumn" style="padding-left: 0;" @click.stop="doThisImages(row.item.attachments)">

                        <div class="items">
                            <viewer-image :images="row.item.attachments" :showImage="false">
                                <template slot="gofixViewer:list_image" slot-scope="{images}">
                                    <div class="item" v-for="attachment in images">
                                        <div class="item-content position-relative" @click="previewFile(attachment)">
                                            <span class="icon" v-html="$options.filters.iconFile(attachment, icons, true)"></span>
                                            <span class="name">{{attachment.image_file_title || attachment.image_file_name}}</span>
                                            <!-- <img class="image-viewer" v-if="checkShowImage(attachment.image_content_type)" v-auth-image="attachment.url.original"  src="img/loading.gif"  :key="attachment.url.original"> -->
                                        </div>
                                    </div>
                                </template>
                            </viewer-image>
                        </div>
                    </div>
                </template>

                <template slot="gofix_table:email" slot-scope="row">
                    <!-- @click.stop="doThisImages(row.item.attachments)" -->
                     <div v-if="row.item.email_id !== null" class="attachmentsColumn" style="padding-left: 0;" >
                         <a class="control-item-link cursor-pointer" @click="EmailView(row.item.email,row.item.remark,row.item.id)">
                             <img src="img/eye_icon.png" alt="New Email" width="20" height="20">
                         </a>
                     </div>
                </template>

                 <template slot="gofix_table:email_status" slot-scope="row">
                    <!-- @click.stop="doThisImages(row.item.attachments)" -->
                        {{ row.item.email_id !== null ? row.item.email.status: '' }}
                     <!-- <div v-if="row.item.email_id !== null" class="attachmentsColumn" style="padding-left: 0;" >
                         <a class="control-item-link cursor-pointer" @click="EmailView(row.item.email,row.item.remark)">
                             <img src="img/eye_icon.png" alt="New Email" width="20" height="20">
                         </a>
                     </div> -->
                </template>
                

                <template slot="gofix_table:email_attachments" slot-scope="row">

                    <div v-if="row.item.email_id !== null && row.item.email.attachments !== null" class="attachmentsColumn" style="padding-left: 0;" @click.stop="doThisImages(row.item.email.attachments)">

                        <div class="items">
                            <viewer-image :images="row.item.email.attachments" :showImage="false">
                                <template slot="gofixViewer:list_image" slot-scope="{images}">
                                    <div class="item" v-for="attachment in images">
                                        <div class="item-content position-relative" @click="previewFile(attachment)">
                                            <span class="icon" v-html="$options.filters.iconFile(attachment, icons, true)"></span>
                                            <span class="name">{{attachment.image_file_title || attachment.image_file_name}}</span>
                                            <!-- <img class="image-viewer" v-if="checkShowImage(attachment.image_content_type)" v-auth-image="attachment.url.original"  src="img/loading.gif"  :key="attachment.url.original"> -->
                                        </div>
                                    </div>
                                </template>
                            </viewer-image>
                        </div>
                    </div>


                    <!-- <div v-if="row.item.email_id !== null && row.item.email.attachments !== null" class="attachmentsColumn" style="padding-left: 0;" >
                         <div class="item" v-for="attachment in row.item.email.attachments">


                              <a class="control-item-link cursor-pointer" :href="attachment.url.original" target="_blank">
                                    <img src="img/navFile.png" alt="New Email" width="20" height="20"><span>{{attachment.image_file_name}}</span>
                              </a>
                         </div>

                    </div> -->


                </template>



            </gofix-default-table>
        </gofix-card>

        <!-- New Email -->
        <b-modal :no-close-on-backdrop="true" id="modal-NewEmail" scrollable
                 :title="modals.addActivity.title" hide-footer
                 :centered="true" v-model="modals.addActivity.open"
                 @hidden="hiddenModalRemark" size='lg'>
            <b-form class="formInvoice pb-11">
                <b-row>
                    <b-col md="12">
                      <gofix-form-dropdown
                          label="Select notification template"
                          vLabel="title"
                          :options="modals.addActivity.emailTemplates"
                          v-model="modals.addActivity.emailTemplate">
                      </gofix-form-dropdown>
                        <gofix-form-input
                            label="FROM"
                            :disabled="true"
                            v-model="modals.addActivity.data.from">
                        </gofix-form-input>
                        <gofix-form-input label="TO" v-model="modals.addActivity.data.to"></gofix-form-input>
                        <gofix-form-input label="CC" v-model="modals.addActivity.data.cc"></gofix-form-input>
                        <gofix-form-input label="Subject" v-model="modals.addActivity.data.subject"></gofix-form-input>
                        <!-- <gofix-form-input-texteditor  label="" content="" v-model="modals.addActivity.data.body"></gofix-form-input-texteditor>                         -->
                        <div class="gofixInput gofixTextAreaInput">
                            <div class="mainInput">
                                <!-- <textarea :value="value"
                                        :disabled="disabled"
                                        :rows="rows"
                                        @change="handleChange"
                                        v-on:keyup="handleInput"
                                        v-on:blur="blurInput = true"
                                v-bind:class="{hasValue:value}"></textarea> -->
                                <!-- v-model="htmlForEditor" -->
                                <vue-editor
                                id="editor"
                                v-model="modals.addActivity.data.body"
                                >
                                </vue-editor>
                            </div>
                            <p class="desc" ></p>
                        </div>



                        <b-form-group label="Attachments" class="photosThumb clear-both">
                            <div class="row">
                            <div class="col-6 mb-3" v-for="(item,index) in modals.addActivity.data.files">
                                <div class="attachmentInfo" v-if="item">

                                    <img v-if="checkShowIcon(item.type || item.image_content_type)" class="icon" :src="item | iconFile(icons)" with="24" height="24" alt="icon-file">
                                    <div class="name">{{item.image_file_title || item.name || item.image_file_name}}</div>
                                    <div class="edit">
                                        <button @click="deleteAttachmentModals(item)" type="button" class="buttonAttachments buttonAttachments__unset">
                                            <svg width="50" height="50" viewBox="0 0 50 50"  xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd"  fill="#999999"/>
                                                <g transform="matrix(0.081382856 0 0 0.081382856 0.063722864 -0)">
                                                    <g>
                                                        <path d="M90.914 5.296C 97.841 -1.7379999 109.102005 -1.769 116.068 5.228C 123.029 12.223 123.059 23.597 116.136 30.625L116.136 30.625L85.743 61.452L116.168 92.307C 123.034 99.284996 122.941 110.587 115.96 117.554C 108.977 124.518 97.75 124.5 90.886 117.523L90.886 117.523L60.669 86.881L30.395 117.58C 23.468 124.614 12.207001 124.645004 5.241001 117.648C -1.7199988 110.653 -1.750999 99.27901 5.1730013 92.25101L5.1730013 92.25101L35.566 61.424007L5.142 30.568C -1.7249999 23.59 -1.6309996 12.288 5.3500004 5.321001C 12.333 -1.6419988 23.56 -1.624999 30.424 5.352001L30.424 5.352001L60.641 35.995003L90.914 5.296z" stroke="none" fill="#000000" fill-rule="nonzero" />
                                                    </g>
                                                </g>
                                            </svg>
                                        </button>

                                    </div>

                                </div>
                            </div>

                            </div>

                          

                            <div class="upload-btn-wrapper">

                                <b-form-file  id="fileInputMulti" v-model="modals.addActivity.data.files" :plain="true" :multiple="true"></b-form-file>

                                <gofix-button class="m-3"  label="file attachment" outline></gofix-button>
                                <!-- <gofix-attachment-area v-if="orderNextStatus === 'Cancelled'" v-model="orderCancelData.files" multiple /> -->


                                <b-button-group>
                                <gofix-button  label="email attachment" @click="modals.searchemail.open = true" outline></gofix-button>
                                </b-button-group>
                                <!-- <b-button type="button" @click="modals.searchemail.open = true">
                                <div class="tooltip">Attach Email</div>
                                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                        <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                        <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                    </svg>
                                </b-button> -->
                            </div>


                        </b-form-group>

                        <gofix-form-input-textarea label="Remark" content="" v-model="modals.addActivity.data.remark"></gofix-form-input-textarea>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <!-- @click="sendEmail" -->
                <gofix-button label="Submit" @click="sendEmail"  :loading="modals.addActivity.loading" noBorder></gofix-button>


            </b-button-group>

            <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Search Email" hide-footer :centered="true" v-model="modals.searchemail.open" size="xli">
                <email-search></email-search>
                <b-button-group class="d-block text-right">
                    <gofix-button label="Close" @click="modals.searchemail.open=false" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </b-modal>


        <!-- Email View -->
        <b-modal :no-close-on-backdrop="false" id="modal-ViewEmail" scrollable :title="modals.viewemail.title" hide-footer :centered="true" v-model="modals.viewemail.open" @hidden="hiddenModalRemark" size='xl' static>
            <b-form class="formInvoice pb-11" id="viewEmailForm" v-bind:class="{'run-loading small-loading':modals.viewemail.loading}">
                <b-row>
                    <b-col md="12">
                        <b-row>
                            <b-col md="6">
                                <gofix-button class="mr-4" label="Reply" @click="replyItemFromViewEmail" outline></gofix-button>
                            </b-col>
                            <b-col md="6">
                                <b-button-group class="d-block text-right">
                                    <b-button @click="downloadEML" class="mr-3 clientPrintIcon" title="Download" v-b-tooltip.hover size="sm"><i class="icon-cloud-download icons"></i></b-button>
                                    <!-- <b-button @click="print" class="mr-3 clientPrintIcon" title="Print" v-b-tooltip.hover size="sm"><i class="icon-printer icons"></i></b-button> -->
                                    <b-button @click="printNative" class="mr-3 clientPrintIcon" title="Browser Print" v-b-tooltip.hover size="sm"><i class="icon-printer icons"></i></b-button>
                                </b-button-group>

                            </b-col>
                        </b-row>
                        <div id="emailHeaders">
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >Date</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.date"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >From</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.from_name_address"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >To</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.to"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >CC</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.cc"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >Subject</span>
                                </div>
                                <div class="textValue">
                                    <span>{{modals.viewemail.data.subject}}</span>
                                </div>
                            </gofix-text-field>
                        </div>
                        <!-- <gofix-form-input-texteditor  label="" content="" v-model="modals.viewemail.data.body" disabled="disabled"></gofix-form-input-texteditor>                         -->
                        <iframe id="iframeNew" ref="iframeNew" :src="modals.iframe.src" width="100%" height="100%" scrolling="auto" @load="iframeNewLoaded"> </iframe>
                        <iframe id="iframePrint" ref="iframePrint" width="100%" height="70%" scrolling="auto" style="display:none"> </iframe>

                        <b-form-group label="Attachments" class="photosThumb clear-both">
                            <b-row>
                                    <b-col class="col-6 mb-3" v-for="(attachment,index) in  modals.viewemail.data.files" :key="index">
                                            <div class="attachmentInfo">
                                               
                                                <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile(icons)" with="24" height="24" alt="icon-file">
                                                <div class="name" @click="previewFile(attachment)">{{attachment.image_file_title || attachment.image_file_name}}</div>
                                            </div>
                                        

                                    </b-col>
                            </b-row>

                            <!-- <ul class="list-thumb" v-if="modals.viewemail.data.files !== null" style="margin-left:100px!important;" >                 
                                <li  v-for="(item,key) in modals.viewemail.data.files" v-bind:key="key" @click="previewFile(item)">  {{item.image_file_name}}  </li>
                            </ul> -->
                        </b-form-group>

                        <!-- <b-form-group label="Attachments" class="photosThumb clear-both">
                            <ul class="list-thumb" v-if="modals.viewemail.data.files !== null" style="margin-left:100px!important;" >
                                <li v-for="(item,key) in modals.viewemail.data.files" v-bind:key="key"> {{item.image_file_name}} </li>
                            </ul>

                          


                        </b-form-group> -->

                        <gofix-form-input-textarea label="Remark" content="" v-model="modals.viewemail.data.remark" disabled="disabled"></gofix-form-input-textarea>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">

            </b-button-group>

            <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Search Email" hide-footer :centered="true" v-model="modals.searchemail.open" size="xli">
                <email-search></email-search>
                <b-button-group class="d-block text-right">
                    <gofix-button label="Close" @click="modals.searchemail.open=false" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </b-modal>

        <!-- modal-Create -->
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.remark.title" hide-footer :centered="true" v-model="modals.remark.open" @hidden="resetModalRemark">
            <b-form class="formInvoice pb-10">
                <b-row align-v="center">
                    <b-col md="5">
                        <gofix-form-input-date
                            label="Action Date"
                            popoverDirection="top"
                            :required="true"
                            :show-icon-required="true"
                            disabled
                            v-model="modals.remark.data.date" >
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="4">
                        <gofix-form-input-time
                            label="Action Time"
                            popoverDirection="top"
                            :required="true"
                            :show-icon-required="true"
                            disabled
                            v-model="modals.remark.data.time" >
                        </gofix-form-input-time>
                    </b-col>
                     <b-col md="3">
                        <div class="action actionFloat actionFloat__extra d-flex font-weight-bold">
                            <b-button type="button" disabled class="pl-0 btnToggleEmail mr-3">
                                <i class="fa fa-commenting-o" aria-hidden="true"></i>
                            </b-button>
                            <b-button type="button" disabled class="pl-0 btnToggleEmail">
                                <i class="fa fa-envelope-o" aria-hidden="true"></i>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="Actor"
                                desc="Search by email"
                                @search="searchUser"
                                :filterable="false"
                                :required="true"
                                :show-icon-required="true"
                                :disabled="!tableConfig.controls.update"
                                v-model="officerName"
                                :options="fmOfficer">
                            <template #gofixInput:dropdown:option="{ user_name, user_email }">
                                {{user_name}} - {{user_email}}
                            </template>
                            <template #gofixInput:dropdown:selected-option="{ user_name, user_email }">
                                {{user_name}} - {{user_email}}
                            </template>
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <!--<gofix-form-input label="Activity" v-model="modals.remark.data.action"></gofix-form-input>-->
                        <gofix-form-dropdown
                            label="Activity"
                            :clearable="true"
                            :show-icon-required="true"
                            :disabled="!tableConfig.controls.update"
                            vLabel="reference_value_text"
                            :selectable="selectableAction"
                            v-model="modals.remark.data.action"
                            :required="true"
                            :options="actionType">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <gofix-form-input-textarea :rows="5" :show-icon-required="true" :disabled="!tableConfig.controls.update" :showClassDisabled="false" :classTextarea="!tableConfig.controls.update ? 'no-drop' : ''" label="Remark" :required="true" v-model="modals.remark.data.remark"></gofix-form-input-textarea>
                    </b-col>
                    <b-col md="12" class="mb-3">
                        <b-form-checkbox :disabled="(!tableConfig.controls.update || (Item && Item.status == 'Closed')) || disabledWithAddNote" v-model="modals.remark.is_allow_change_status" class="ml-3 d-inline-block"><span class="ml-2">Change case status</span></b-form-checkbox>
                    </b-col>
                    <b-col md="12" class="mb-3">
                        <b-form-checkbox disabled class="ml-3 d-inline-block"><span class="ml-2">Send email</span></b-form-checkbox>
                    </b-col>
                    <b-col md="12" class="mb-3">
                        <b-form-checkbox disabled class="ml-3 d-inline-block"><span class="ml-2">SMS</span></b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-row class="mb-3">
                            <div class="action actionFloat actionFloat__extra d-flex font-weight-bold">
                                <div class="title pl-15">Attachments</div>
                                <b-button @click="deleteAttachment" v-if="tableConfig.controls.update && modals.remark.attachmentDeleteId.length">
                                    <div class="tooltip">Delete</div>
                                    <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                        <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                    </svg>
                                </b-button>
                                <b-button type="button" @click="modals.attachment.open = true" v-if="tableConfig.controls.update">
                                    <div class="tooltip">Create</div>
                                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                        <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                        <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                    </svg>
                                </b-button>
                                <b-button type="button" @click="dowloadAttachments" v-if="modals.remark.attachmentDeleteId.length && !disabledWithAddNote">
                                    <div class="tooltip">Download</div>
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.78216 9.13875L8.80055 11.2538V1.5C8.80055 0.88125 9.28367 0.375 9.87416 0.375C10.4646 0.375 10.9478 0.88125 10.9478 1.5V11.2538L12.9769 9.13875C13.3956 8.7 14.072 8.7 14.4907 9.13875C14.6917 9.34894 14.8047 9.63429 14.8047 9.93188C14.8047 10.2295 14.6917 10.5148 14.4907 10.725L10.6364 14.7638C10.2177 15.2025 9.54134 15.2025 9.12263 14.7638L5.26837 10.725C4.84967 10.2863 4.84967 9.5775 5.26837 9.13875C5.68708 8.7 6.36345 8.7 6.78216 9.13875ZM17.4004 17.25V11.625C17.4004 11.0062 17.8835 10.5 18.474 10.5C19.0645 10.5 19.5476 11.0062 19.5476 11.625V18.375C19.5476 19.6125 18.5814 20.625 17.4004 20.625H2.36987C1.1889 20.625 0.222656 19.6125 0.222656 18.375V11.625C0.222656 11.0062 0.70578 10.5 1.29626 10.5C1.88675 10.5 2.36987 11.0062 2.36987 11.625V17.25C2.36987 17.8687 2.853 18.375 3.44348 18.375H16.3268C16.9173 18.375 17.4004 17.8687 17.4004 17.25Z" fill="#999999"/>
                                    </svg>
                                </b-button>
                            </div>
                        </b-row>
                        <b-row>
                            <b-col class="col-6 mb-3" v-for="(attachment,index) in modals.remark.attachments" :key="index">
                                <div class="attachmentInfo">
                                    <div class="checkbox">
                                        <b-form-checkbox class="uniform" :value="index" v-model="modals.remark.attachmentDeleteId"></b-form-checkbox>
                                    </div>
                                    <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile(icons)" with="24" height="24" alt="icon-file">
                                    <div class="name">{{attachment.image_file_title || attachment.image_file_name}}</div>
                                </div>
                            </b-col>
                            <b-col class="col-6 mb-3" v-for="(attachment,index) in modals.remark.attachment_tmp.add" :key="'tmp'+index">
                                <div class="attachmentInfo">
                                    <div class="checkbox">
                                        <b-form-checkbox class="uniform" :value="'tmp'+index" v-model="modals.remark.attachmentDeleteId"></b-form-checkbox>
                                    </div>
                                    <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile(icons)" with="24" height="24" alt="icon-file">
                                    <div class="name">{{attachment.image_file_title || attachment.name}}</div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <!-- <gofix-button v-if="this.modals.remark.data.id && contracts && contracts.case_settings && contracts.case_settings.is_use_nlt_case_module" label="UPDATE & CHANGE STATUS" @click="saveActivity(true)" :loading="modals.remark.loading_save_status" noBorder></gofix-button>
                <gofix-button v-if="!this.modals.remark.data.id && contracts && contracts.case_settings && contracts.case_settings.is_use_nlt_case_module" label="SAVE & UPDATE STATUS" @click="saveActivity(true)" :loading="modals.remark.loading_save_status" noBorder></gofix-button> -->
                <gofix-button :label="modals.remark.button_label" :disabled="!tableConfig.controls.update" @click="saveActivity(true)" :loading="modals.remark.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>

        <!-- latestEmail -->
        <b-modal :no-close-on-backdrop="true" id="modal-Latest-Email" hide-footer hide-header :centered="true" v-model="modals.latestEmail.open">
            <div class="center">You are not replying to the latest email thread. You can search for it by filtering the Subject column in Email Listing. If you would like to proceed with the reply, click "Confirm", else click "Cancel"</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="latestEmailCancel">Cancel</b-button>
                <b-button class="custom-btn" :disabled="modals.latestEmail.loading" @click="latestEmailConfirm"> <b-spinner v-if="modals.latestEmail.loading" small type="grow"></b-spinner> Confirm</b-button>
            </b-button-group>
        </b-modal>

        
        <!-- replyingToConfirm -->
        <b-modal :no-close-on-backdrop="true" id="modal-Replying-To-Confirm" hide-footer hide-header :centered="true" v-model="modals.replyingToConfirm.open">
            <div class="center rpl-message">You are replying to {{modals.replyingToConfirm.from}},<br>do you want to proceed?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="replyingToCancelBtnClick">Cancel</b-button>
                <b-button class="custom-btn" :disabled="modals.replyingToConfirm.loading" @click="replyingToConfirmBtnClick"> <b-spinner v-if="modals.replyingToConfirm.loading" small type="grow"></b-spinner> Confirm</b-button>
            </b-button-group>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments" id="modal-Contract-Attachments" hide-footer v-model="modals.attachment.open">
            <b-form class="formV2">
                <gofix-form-input label="File Title" v-model="modals.attachment.image_file_title"></gofix-form-input>
                <b-form-group :label="modals.attachment.filename">
                    <b-form-file ref="file-input" v-model="modals.attachment.fileAttachment" ></b-form-file>
                </b-form-group>
                <!-- <b-form-group>
                    <b-form-file ref="file-input" v-model="modals.attachment.fileAttachment" >
                        <template slot="file-name" slot-scope="{ names }">
                            <span class="import-input-text-ellipsis">{{ names[0] }}</span>
                        </template>
                    </b-form-file>
                </b-form-group> -->
                <b-button-group class="text-right d-block">
                    <gofix-button label="SUBMIT" @click="addAttachment" noBorder :loading="modals.attachment.loading"></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <!--File form edit-->
        <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments-edit" id="modal-Contract-Attachments" hide-footer>
            <b-form class="formV2">
                <gofix-form-input label="File Title" v-model="modals.attachment.image_file_title"></gofix-form-input>
                <b-form-group :label="modals.attachment.filename">
                    <b-form-file ref="file-input" v-model="modals.attachment.fileAttachment" ></b-form-file>
                </b-form-group>
                <b-button-group class="text-right d-block">
                    <gofix-button label="SUBMIT" @click="addAttachment" noBorder :loading="modals.attachment.loading"></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.closeCase.open">
            <div class="center">Do you want to close <strong>this case</strong>?<br>This cannot be undone. The case will be locked, no more change or addition of activity.</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.closeCase.open = false">Cancel</b-button>
                <b-button class="custom-btn" :disabled="modals.closeCase.loading" @click="saveActivity(false)"> <b-spinner v-if="modals.closeCase.loading" small type="grow"></b-spinner> Confirm</b-button>
            </b-button-group>
        </b-modal>
        <Escalation v-model="modals.escalation.open" :nltAction="{label: 'Create Activity Log'}" :disableActionTime="true" @updateSuccess="refreshData"/>


        <b-modal :no-close-on-backdrop="true" id="modal-Print" title="Print PDF" hide-footer :centered="true" v-model="modals.printPDF.open_process" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
                <b-progress-bar :value="100">
                    <span class="font-size-16">{{modals.printPDF.process}}</span>
                </b-progress-bar>
            </b-progress>
          </b-modal>
        <!-- modal Reply -->
        <Reply v-model="modals.reply.open" :nltAction="{label: 'Reply Email'}" :email="modals.reply.email" @updateSuccess="refreshData"></Reply>
        <!-- modal End -->
        <div v-show="0">
        <div  ref="signature">
          <p>&nbsp;</p>
          <p style="line-height: 1.5; margin: 0px;"><span style="font-size: 11pt;">Thank you</span></p>
          <p style="line-height: 1.5; margin: 0px;">&nbsp;</p>
          <p style="line-height: 1.5; margin: 0px;"><span style="font-size: 11pt; font-family: arial, helvetica, sans-serif;">Best regards,</span></p>
          <p style="line-height: 1.5; margin: 0px;"><span style="font-size: 11pt; font-family: arial, helvetica, sans-serif;">[Agent name]</span></p>
          <p style="line-height: 1.5; margin: 0px;"><span style="font-size: 11pt; font-family: arial, helvetica, sans-serif;">Customer Service Team</span></p>
          <p style="line-height: 1.5; margin: 0px;"><span style="font-size: 11pt; font-family: arial, helvetica, sans-serif;">Netlink Trust Call Centre</span></p>
          <p style="line-height: 1.5; margin: 0px;"><span style="font-size: 11pt; font-family: arial, helvetica, sans-serif;"><strong>T:&nbsp;</strong>65 6563 4273</span></p>
          <p style="line-height: 1.5; margin: 0px;"><span style="font-size: 11pt; font-family: arial, helvetica, sans-serif;"><strong>B:&nbsp;</strong>65 3163 4401</span></p>
          <p><img src="https://nlt-api.gofix.com.sg/images/nlt/logoNextLink.png" width="240" height="56" /></p>
          <p><span style="font-family: arial, helvetica, sans-serif; font-size: 8pt;">Follow us on social media:</span></p>
          <p><a href="https://www.facebook.com/NetLinkTrust" target="_blank" rel="noopener"><img src="https://nlt-api.gofix.com.sg/images/nlt/facebook.png" width="24" height="24" /></a> &nbsp;<a href="https://www.linkedin.com/company/netlink-nbn-trust" target="_blank" rel="noopener"><img src="https://nlt-api.gofix.com.sg/images/nlt/linkedin.png" width="24" height="24" /></a> &nbsp;<a href="https://www.youtube.com/channel/UChdvEbbu8KqL8CbX24uOcFQ" target="_blank" rel="noopener"><img src="https://nlt-api.gofix.com.sg/images/nlt/youtube.png" width="24" height="24" /></a></p>
        </div>
      </div>
    </div>
</template>
<script>
    import moment from 'moment';
    import { mapGetters } from "vuex";
    import JsonViewer from 'vue-json-viewer';
    import { filters } from '@/_filterVar.js';
    const ViewerImage = () => import('../plugins/ViewerImage.vue')
    const emailSearch = () => import('../email-integration/search.vue')
    import { VueEditor } from "vue2-editor";
    const Escalation = () => import("./Escalation")
    const Reply = () => import("./Reply")
    import html2pdf from 'html2pdf.js';

    export default {
        name: 'payment-voucher-info',
        props: {
            activityType: {
                type: String,
                default: null
            },
            activityId: {
                type: [String,Number],
                default: null
            },
            controls: {
                type: Object,
                default: () => {
                    return {
                        create: true,
                        delete: false,
                        update: true,
                        resend: true,
                    }
                }
            },
            isCaseActivity: {
                type: Boolean,
                default: false,
            },
            disableImport: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            JsonViewer,
            ViewerImage,
            emailSearch,
            VueEditor,
            Escalation,
            Reply
        },
        data() {
            let filter =  JSON.parse(JSON.stringify(filters['case_activities_log']));
            return {
                modals:{
                    iframeEl: null,
                    iframeElPrint: null,
                    iframe:{
                        src:"",
                    },
                    searchemail:{
                        open:false
                    },
                    remark:{
                        open:false,
                        loading:false,
                        loading_save_status: false,
                        is_allow_change_status: false,
                        data:{
                            id:null,
                            remark: null,
                            date:null,
                            time:null,
                            time_stamp:null,
                            actor:null,
                            actor_id:null,
                            action:null,
                            log_type:'Manual',
                        },
                        attachments: [],
                        attachmentUpdate: [],
                        attachmentDeleteId: [],
                        attachment_tmp: {
                            delete: [],
                            add:[],
                            update: []
                        },
                        title: 'Create Activity Log',
                        button_label:'SUBMIT'
                    },
                    addActivity:{
                      open:false,
                      loading:false,
                      data:{
                          id:null,
                          from:null,
                          to: null,
                          cc:null,
                          subject:null,
                          body:"<h1> </h1>",
                          remark:null,
                          files: null,
                      },
                      title: 'New Email',
                      fromMails: (process.env.VUE_APP_ENVIRMENT && process.env.VUE_APP_ENVIRMENT !== 'prod') ? ['ask.stg@emservices.com.sg','cstl.stg@emservices.com.sg','qp.stg@emservices.com.sg'] : ['ask@netlinknbn.com','cstl@netlinknbn.com','qpmail@netlinknbn.com'],
                      emailTemplates:[],
                      emailTemplate: null,

                    },
                    viewemail:{
                        open:false,
                        loading:false,
                        data:{
                            id:null,
                            to: null,
                            cc:null,
                            subject:null,
                            body:"<h1>Some initial content</h1>",
                            remark:null,
                            files: null,
                            mail_box: null,
                            activity_id: null,
                        },
                        title: 'View Email',

                    },
                    closeCase: {
                        open: false,
                        loading: false
                    },
                    ids:[],
                    status:{
                        loading:false,
                        open:false
                    },
                    attachment:{
                        open:false,
                        loading: false,
                        filename: "Click Browse to upload file",
                        fileAttachment:null,
                        image_file_title: '',
                        id: 0,
                        index: '',
                        edit: 0
                    },
                    is_outdate:false,
                    caseStatus:null,
                    escalation:{
                        open:false,
                    },
                    reply:{
                        open:false,
                        email:null
                    },
                    latestEmail:{
                        open:false
                    },
                    replyingToConfirm:{
                        open:false,
                        from: ''
                    },
                    printPDF : {
                        open: false,
                        loading: false,
                        process: 'Printing PDF',
                        open_process: false
                    }
                },
                contracts:null,
                actionType:[],
                officerName:null,
                fmOfficer:[],
                timer:null,
                attachments_show_modal : [],
                images : [],
                icons: {
                    'application': {
                        'word': {
                            'img': 'word.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094ZM9.28301 8.29688H8.71699C8.62031 8.29688 8.53594 8.36191 8.51309 8.45684L7.63945 11.9531L6.8291 8.46035C6.80625 8.36543 6.72187 8.29688 6.62344 8.29688H6.00117C5.96884 8.29693 5.93695 8.3044 5.90795 8.31871C5.87896 8.33303 5.85364 8.3538 5.83395 8.37945C5.81425 8.40509 5.8007 8.43491 5.79434 8.46661C5.78798 8.49831 5.78898 8.53105 5.79727 8.5623L7.10156 13.4139C7.12617 13.5053 7.21055 13.5703 7.30547 13.5703H7.86797C7.96289 13.5703 8.04727 13.507 8.07188 13.4139L9 9.95098L9.92812 13.4139C9.95273 13.5053 10.0371 13.5703 10.132 13.5703H10.691C10.7859 13.5703 10.8703 13.507 10.8949 13.4139L12.2027 8.5623C12.2109 8.53105 12.2119 8.49834 12.2055 8.46667C12.1991 8.43499 12.1856 8.4052 12.1659 8.37958C12.1462 8.35396 12.1209 8.33318 12.0919 8.31885C12.063 8.30451 12.0311 8.29699 11.9988 8.29688H11.373C11.2746 8.29688 11.1902 8.36543 11.1674 8.46035L10.3623 11.9602L9.48691 8.45684C9.46406 8.36191 9.37969 8.29688 9.28301 8.29688Z" fill="#666666"/></svg>'
                        },
                        'excel': {
                            'img': 'excel.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125ZM12.0492 13.5961L10.6008 11.1961C10.5492 11.1117 10.4578 11.0602 10.3594 11.0602H9.45938C9.40547 11.0602 9.35391 11.0742 9.30938 11.1047C9.17813 11.1867 9.13828 11.3602 9.22266 11.4937L11.1516 14.55L9.19687 17.6625C9.17032 17.7052 9.15565 17.7542 9.15438 17.8045C9.15312 17.8547 9.1653 17.9044 9.18968 17.9484C9.21405 17.9923 9.24973 18.029 9.29303 18.0546C9.33632 18.0801 9.38566 18.0937 9.43594 18.0938H10.2445C10.343 18.0938 10.432 18.0422 10.4836 17.9602L11.9531 15.5812L13.4133 17.9578C13.4648 18.0422 13.5562 18.0914 13.6523 18.0914H14.5312C14.5852 18.0914 14.6367 18.075 14.6836 18.0469C14.8148 17.9625 14.8523 17.7891 14.768 17.6578L12.7992 14.6016L14.7984 11.4961C14.8255 11.4535 14.8407 11.4045 14.8423 11.3541C14.844 11.3037 14.8322 11.2537 14.808 11.2095C14.7838 11.1652 14.7482 11.1282 14.7049 11.1024C14.6616 11.0765 14.6122 11.0628 14.5617 11.0625H13.725C13.6266 11.0625 13.5352 11.1141 13.4836 11.1984L12.0492 13.5961Z" fill="#666666"/></svg>'
                        },
                        'pdf': {
                            'img': 'pdf.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33926 10.0969L9.34453 10.0723C9.44648 9.65215 9.5748 9.12832 9.47461 8.65371C9.40781 8.2793 9.13184 8.1334 8.89629 8.12285C8.61855 8.11055 8.3707 8.26875 8.30918 8.49902C8.19316 8.9209 8.29688 9.49746 8.48672 10.2322C8.24766 10.8018 7.86621 11.6297 7.58672 12.1219C7.06641 12.3908 6.36855 12.8057 6.26484 13.3295C6.24375 13.4262 6.26836 13.5492 6.32637 13.66C6.39141 13.783 6.49512 13.8779 6.61641 13.9236C6.66914 13.943 6.73242 13.9588 6.80625 13.9588C7.11563 13.9588 7.6166 13.7092 8.28457 12.5631C8.38652 12.5297 8.49199 12.4945 8.59395 12.4594C9.07207 12.2977 9.56777 12.1289 10.016 12.0533C10.5117 12.3188 11.076 12.4893 11.4592 12.4893C11.8389 12.4893 11.9883 12.2643 12.0445 12.1289C12.143 11.8916 12.0955 11.5928 11.9355 11.4328C11.7035 11.2043 11.1393 11.1445 10.2604 11.2535C9.82793 10.9898 9.54492 10.6313 9.33926 10.0969ZM7.41094 12.767C7.1666 13.1221 6.98203 13.2996 6.88184 13.377C6.99961 13.1607 7.22988 12.9322 7.41094 12.767ZM8.95078 8.62734C9.04219 8.78379 9.02988 9.25664 8.95957 9.4957C8.87344 9.1459 8.86113 8.6502 8.91211 8.59219C8.92617 8.59395 8.93848 8.60449 8.95078 8.62734ZM8.92266 10.7455C9.11074 11.0707 9.34805 11.3502 9.60996 11.5576C9.23027 11.6438 8.88398 11.7861 8.57461 11.9127C8.50078 11.9426 8.42871 11.9725 8.3584 12.0006C8.59219 11.577 8.7873 11.0971 8.92266 10.7455ZM11.6578 11.8969C11.6596 11.9004 11.6613 11.9057 11.6508 11.9127H11.6473L11.6438 11.918C11.6297 11.9268 11.4855 12.0111 10.865 11.7668C11.5787 11.7334 11.6561 11.8951 11.6578 11.8969ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                        },
                        'outlook': {
                            'img': 'outlook.png'
                            ,'svg': '<svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="18px" height="18px"><path d="M 23.607422 4.0429688 C 23.347041 4.0335549 23.0813 4.0541387 22.814453 4.1074219 L 7.6171875 7.1464844 C 5.5228355 7.5659519 4 9.4229991 4 11.558594 L 4 36.441406 C 4 38.576376 5.5230144 40.434668 7.6171875 40.853516 L 22.814453 43.892578 C 24.948801 44.31917 27 42.637467 27 40.460938 L 27 38 L 39.5 38 C 42.519774 38 45 35.519774 45 32.5 L 45 16.5 C 45 13.480226 42.519774 11 39.5 11 L 27 11 L 27 7.5390625 C 27 5.6340003 25.430086 4.1088659 23.607422 4.0429688 z M 23.402344 7.0488281 C 23.741566 6.9810934 24 7.1922764 24 7.5390625 L 24 40.460938 C 24 40.807724 23.741273 41.019122 23.402344 40.951172 A 1.50015 1.50015 0 0 0 23.402344 40.949219 L 8.2070312 37.910156 A 1.50015 1.50015 0 0 0 8.2050781 37.910156 C 7.4941947 37.768284 7 37.165812 7 36.441406 L 7 11.558594 C 7 10.834188 7.4953833 10.230423 8.2070312 10.087891 L 23.402344 7.0488281 z M 27 14 L 39.5 14 C 40.898226 14 42 15.101774 42 16.5 L 42 17.226562 L 30.5 24.710938 L 27 22.433594 L 27 14 z M 15.5 16.5 C 13.557292 16.5 12.018637 17.783982 11.183594 19.310547 C 10.34855 20.837112 10 22.669872 10 24.5 C 10 26.330128 10.34855 28.162888 11.183594 29.689453 C 12.018637 31.216018 13.557292 32.5 15.5 32.5 C 17.442708 32.5 18.981363 31.216018 19.816406 29.689453 C 20.65145 28.162888 21 26.330128 21 24.5 C 21 22.669872 20.65145 20.837112 19.816406 19.310547 C 18.981363 17.783982 17.442708 16.5 15.5 16.5 z M 15.5 19.5 C 16.223957 19.5 16.685305 19.841018 17.183594 20.751953 C 17.681883 21.662888 18 23.080128 18 24.5 C 18 25.919872 17.681883 27.337112 17.183594 28.248047 C 16.685305 29.158982 16.223957 29.5 15.5 29.5 C 14.776043 29.5 14.314695 29.158982 13.816406 28.248047 C 13.318117 27.337112 13 25.919872 13 24.5 C 13 23.080128 13.318117 21.662888 13.816406 20.751953 C 14.314695 19.841018 14.776043 19.5 15.5 19.5 z M 42 20.806641 L 42 32.5 C 42 33.898226 40.898226 35 39.5 35 L 27 35 L 27 26.011719 L 29.681641 27.757812 A 1.50015 1.50015 0 0 0 31.318359 27.757812 L 42 20.806641 z"/></svg>'
                        },
                    },
                    'image': {
                        'img': 'image.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72246 8.94902L8.35488 10.6928L7.63242 9.77168C7.61927 9.75487 7.60246 9.74128 7.58327 9.73193C7.56409 9.72258 7.54302 9.71772 7.52168 9.71772C7.50034 9.71772 7.47927 9.72258 7.46009 9.73193C7.4409 9.74128 7.42409 9.75487 7.41094 9.77168L5.65664 12.0076C5.64041 12.0283 5.63034 12.0532 5.62758 12.0794C5.62482 12.1056 5.62948 12.132 5.64104 12.1557C5.65259 12.1793 5.67056 12.1992 5.69291 12.2132C5.71525 12.2271 5.74106 12.2344 5.76738 12.2344H12.2344C12.3521 12.2344 12.4172 12.099 12.3451 12.0076L9.9457 8.94902C9.93237 8.93219 9.91541 8.91859 9.89608 8.90924C9.87675 8.89989 9.85555 8.89503 9.83408 8.89503C9.81261 8.89503 9.79142 8.89989 9.77209 8.90924C9.75276 8.91859 9.73579 8.93219 9.72246 8.94902ZM6.32812 7.76953C6.32812 7.95601 6.4022 8.13485 6.53407 8.26672C6.66593 8.39858 6.84477 8.47266 7.03125 8.47266C7.21773 8.47266 7.39657 8.39858 7.52843 8.26672C7.6603 8.13485 7.73438 7.95601 7.73438 7.76953C7.73438 7.58305 7.6603 7.40421 7.52843 7.27235C7.39657 7.14049 7.21773 7.06641 7.03125 7.06641C6.84477 7.06641 6.66593 7.14049 6.53407 7.27235C6.4022 7.40421 6.32812 7.58305 6.32812 7.76953ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                    },
                    'text': {
                        'img': 'notepad.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
                    },
                    'inode': 'none'
                },
                tableConfig:{
                    name: 'case-management-activity-logs',
                    controls:{
                        create: true,
                        // createEmail:true,
                        reply:true,
                        createTooptip: "Add Activity Log",
                        caseStatus: '',
                        // createEmailTooltip:"New Email",
                        //renameField: this.isCaseActivity ? true : false,
                        tableImport: this.disableImport ? false : true,
                      update:true
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "created_at",
                    sortDirection: "desc",
                    /*fields: [
                        {
                            key: 'created_at',
                            label: 'Time Stamp',
                            isActive: 1,
                            isFilter: true,
                            with:150,
                            thStyle: "width:150px",
                            sorting: true,
                        }
                        ,{
                            key: 'action',
                            label: 'Activity',
                            thStyle: "width:180px",
                            isActive: 1,
                            isFilter: true,
                            with:150,
                            sorting: true,
                        },
                        {
                            key: 'actor_name',
                            label: 'User',
                            isActive: 1,
                            isFilter: true,
                            with:150,
                            thStyle: "width:150px",
                            sorting: true,
                        },
                        {
                            key: 'remark',
                            label: 'Remark',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:auto",
                            sorting: true,
                        },
                    ]*/
                },
                render:0,
                tableItems: [],
                optionFilter:[
                    {label:'Main Activities', value: 'main'},
                    {label:'All Activities',value: 'all'},
                ],
                isFilterDrp: 'main',
                disabledWithAddNote: false
            }
        },
        computed: {
            ...mapGetters({
                Item: "CaseManagementController/Item",
                UserLogin: "AuthController/user",
            })
        },
        mounted() {
            this.modals.iframeEl=this.$refs.iframeNew;
            this.modals.iframeElPrint=this.$refs.iframePrint;
        },
        watch: {
            controls: function(val) {
                this.tableConfig.controls = Object.assign(this.tableConfig.controls, val);
                
            },
            "modals.attachment.fileAttachment": function(val, old) {
                this.modals.attachment.filename = 'Click Browse to upload file';
                if (val) {
                    let extensionAccept = ['csv', 'pdf', 'txt', 'jpeg', 'jpg', 'png', 'gif','msg','html','htm','zip','eml'];
                    let extensionArray = val.name.split('.');
                    let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                    if(!extensionAccept.includes(extension)) {
                        this.$refs['file-input'].reset()
                        return this.$alertNotification("File format is incorrect. Please select a .zip, .html, .msg, .csv, .pdf, .txt, .jpeg, .jpg, .png, .gif, .eml file!", "warning");
                    }
                    this.modals.attachment.filename = val.name
                }
            },
            "modals.attachment.open": function(val) {
                if(val == true) {
                    this.resetFormImport();
                }
            },
            "modals.addActivity.emailTemplate": function(val) {
              if(val && val.content){
                this.modals.addActivity.data.body = val.content;
              }else{
                this.modals.addActivity.data.body = null;
              }

              if(val && val.from){
                this.modals.addActivity.data.from = val.from;
              }else{
                this.modals.addActivity.data.from = null;
              }

            },
            Item: function(val) {
                if(val && val.status && val.status == 'Closed') {
                    this.tableConfig.controls = {
                        create: true,
                        delete: false,
                        createTooptip: "Add Activity Log",
                        tableImport: false,
                        update: this.$checkRole(this.$accessModule.amend_closed_case_activity, 'amend_closed_case_activity')
                    }
                }
                console.log(this.$checkRole(this.$accessModule.amend_closed_case_activity, 'amend_closed_case_activity'))
              this.getEmailTemplates();
            }
        },
        filters: {
            isJson(value) {
                try {
                    JSON.parse(value);
                } catch (e) {
                    return value;
                }
                return JSON.parse(value);
            },
            iconFile(val, icons, is_svg = false) {
                let path = 'img/';
                let type_show = 'img';
                let extension = '';
                let type = val.type || val.image_content_type;

                if(is_svg) {
                    path = '';
                    type_show = 'svg';
                }
                if(val.type) extension = val.name.split('.')[1];

                let arrTemp = type.split('/');
                if(arrTemp && arrTemp.length == 2) {
                    let type = arrTemp[0];
                    if(!extension) extension = arrTemp[1];

                    if(type == 'application' || type == 'inode' || type == 'text' || type == 'message') {
                        let key = 'pdf';
                        if(['docx', 'doc', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'msword'].includes(arrTemp[1])) key = 'word';
                        if(['xls', 'xlsx', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.ms-excel'].includes(arrTemp[1])) key = 'excel';
                        if(['zip', 'x-empty', 'plain'].includes(arrTemp[1])) {
                            let extension = val.image_file_name.split('.')[1];
                            if(['doc', 'docx'].includes(extension)) key = 'word';
                            if(['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';
                        }
                        if(['rfc822'].includes(arrTemp[1])) key = 'outlook';
                        return `${path}${icons['application'][key][type_show]}`;
                    }

                    return `${path}${icons[type][type_show]}`;
                }
            }
        },
        async created() {
            this.tableConfig.controls = Object.assign(this.tableConfig.controls, this.controls);
            await this.getCaseEdit();
            await this.getUsers();
            await this.getCaseActivityOptions();
            if(this.caseStatus && this.caseStatus == 'Closed'){
                this.tableConfig.controls.create = true;
                this.tableConfig.controls.createEmail = false;
                this.tableConfig.controls.caseStatus = this.caseStatus;
                this.tableConfig.controls.update = this.$checkRole(this.$accessModule.amend_closed_case_activity, 'amend_closed_case_activity');
                this.render += 1;
            }
            this.getEmailTemplates();
        },
        methods: {
            async getCaseEdit() {
                let case_id = this.$route.params.id;
                if(case_id){
                await this.$store.dispatch('CaseManagementController/getCase', {
                        case_id: case_id
                    })
                    .then(response => {
                        this.contracts = response.data.data.contract;
                        this.caseStatus = response.data.data.status;
                    })
                    .catch(err => {
                        //this.$alertNotification("Can not load the case", "danger");
                    })
                }
            },
            async getCaseActivityOptions(){
                let filter = {reference_type: "Case Activity",contract_id:this.contracts && this.contracts.id };
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.actionType = response.items;
                    })
            },
            async getUsers(){
                let filter = {user_name:{type:"text",value:"",function:"ilike",with:[]},user_email:{type:"text",value:"",function:"ilike",with:[]},user_type:{type:"text",value:"FM Officer",function:"ilike",with:[]},contract_id:{type:"number",value:this.contracts && this.contracts.id,function:"=",with:[]}};
                let request = {
                    limit: 100,
                    page: 1,
                    isCMS:1,
                    sortColumn:'user_id',
                    sortDirection:'ASC',
                    filter: filter,
                    useDatabaseView:true
                };
                this.$store.dispatch("UserDutyController/getItems", request)
                    .then(result=>{
                        this.fmOfficer = result.items;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            async searchUser (search, loading){
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                let filter = {user_name:{type:"text",value:'',function:"ilike",with:[]},user_email:{type:"text",value:search,function:"ilike",with:[]},user_type:{type:"text",value:"FM Officer",function:"ilike",with:[]},contract_id:{type:"number",value:this.contracts && this.contracts.id,function:"=",with:[]}};
                let request = {
                    limit: 100,
                    page: 1,
                    isCMS:1,
                    sortColumn:'user_id',
                    sortDirection:'ASC',
                    filter: filter,
                    useDatabaseView:true
                };
                this.timer = setTimeout(() => {
                    this.$store.dispatch("UserDutyController/getItems", request)
                        .then(response => {
                            this.fmOfficer = response.items;
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },
            async filterList(){
                this.$refs.gofixTable.reloadTableKeepFilter();
            },
            async previewFile(attachment) {
                if(attachment.image_content_type && 
                   (attachment.image_content_type.includes('image') ||
                    attachment.image_content_type.includes('pdf')
                )
                ){
                    const link = document.createElement('a');
                    var path = this.$router.resolve({name: 'FilePreview', params: {file_id: attachment.id}}).href;
                    link.href= path;
                    link.setAttribute('target', '_blank');
                    document.body.appendChild(link);
                    link.click();
                }
                else{
                    await this.downloadAttachment(attachment);
                }
            },
            async downloadAttachment(item){
                        let url = item.url.original;
                        let params = {};
                        params.url = url;
                        params.image_file_name = item.image_file_name;

                        await this.$store.dispatch("FileDownloadController/getFile", params)
                        .then(response => {
                        })
                        .catch(err => {
                            this.$alertNotification("Can not download file", "danger");
                            console.log(err);
                        });
                    
                    return this.$alertNotification("Download attachment successfully!");
                
            },
            deleteAttachmentModals(item) {
                // delete item;
                console.log(item.name);

                this.modals.addActivity.data.files=this.modals.addActivity.data.files.filter(obj => obj.name != item.name);


            },
            checkShowIcon(val) {
                if(!val) return false;
                let type = val.type || val.image_content_type;
                if(!type) return false;
                let arrTemp = type.split('/');
                if(!arrTemp || arrTemp.length < 2 || !this.icons[arrTemp[0]]) return false;
                return true;
            },
            checkShowImage(val) {
                if(!val) return false;
                let arrTemp = val.split('/');
                if(!arrTemp || arrTemp.length < 2 || arrTemp[0] != 'image' ) return false;
                return true;
            },
            doThisImages: function (attachments) {
                this.images = attachments
            },
            modalThumb(attachments) {
                this.attachments_show_modal = []
                if(attachments) {
                    this.attachments_show_modal = attachments
                }
                this.$refs['modalThumb'].show()
            },
            async dowloadAttachments(){
                if(this.modals.remark.attachmentDeleteId.length > 0){
                    for(let index of this.modals.remark.attachmentDeleteId){
                        let item = this.modals.remark.attachments[index];
                        // axios({
                        //     url: item.url.original,
                        //     method: 'GET',
                        //     responseType: 'blob',
                        //     headers: {
                        //         'Authorization': ''
                        //     }
                        // }).then((response) => {
                        //     const url = window.URL.createObjectURL(new Blob([response.data]));
                        //     const link = document.createElement('a');
                        //     link.href = url;
                        //     link.setAttribute('download', item.image_file_name);
                        //     document.body.appendChild(link);
                        //     link.click();
                        // });
                        let url = item.url.original;
                        let params = {};
                        params.url = url;
                        params.image_file_name = item.image_file_name;

                        await this.$store.dispatch("FileDownloadController/getFile", params)
                        .then(response => {
                        })
                        .catch(err => {
                            this.$alertNotification("Can not download file", "danger");
                            console.log(err);
                        });
                    }
                    return this.$alertNotification("Download attachment successfully!");
                }
            },
            deleteAttachment(){
                if(this.modals.remark.attachmentDeleteId.length > 0){
                    this.modals.remark.attachmentDeleteId = this.modals.remark.attachmentDeleteId.sort().reverse();
                    for(let index of this.modals.remark.attachmentDeleteId){
                        if( typeof(index) == "string" && index.includes("tmp")) {
                            index = index.slice(3);
                            this.modals.remark.attachment_tmp.add.splice(index, 1);
                        }else {
                            let item = this.modals.remark.attachments.splice(index, 1);
                            this.modals.remark.attachment_tmp.delete.push(item[0])
                        }
                    }
                    this.modals.remark.attachmentDeleteId.length = 0;
                }
            },
            EmailView(email,remark,activity_id){
                this.modals.viewemail.loading = true;
                this.selectedEmail = email;
                this.EmailTitle='Email View';

                this.modals.viewemail.open=true;
                this.modals.viewemail.data.from=this.selectedEmail.from;
                this.modals.viewemail.data.to=this.selectedEmail.to;
                this.modals.viewemail.data.cc=this.selectedEmail.cc;
                this.modals.viewemail.data.subject=this.selectedEmail.subject;
                this.modals.viewemail.data.date=this.selectedEmail.date;
                this.modals.viewemail.data.from_name=this.selectedEmail.from_name;
                this.modals.viewemail.data.from_name_address=this.selectedEmail.from_name_address;
                this.modals.viewemail.data.mail_box = this.selectedEmail.mail_box;
                this.modals.viewemail.data.activity_id = activity_id;


                let params = Object.assign({
                        email_id: this.selectedEmail.id
                });

                
                this.$store.dispatch("EmailIntegrationController/EachEmail", params)
                .then(response => {

                    this.modals.iframeEl.style.height = 350 +'px';
                    var doc=this.modals.iframeEl.contentWindow.document;
                    doc.open();
                    doc.write(response.data.data.body!=null?response.data.data.body:"");
                    doc.close();
                    this.selectedEmail.body = response.data.data.body;
                    this.modals.viewemail.loading = false;    
                })
                .catch(err => {
                    console.log(err);
                    this.modals.viewemail.loading = false;
                    this.$alertNotification("Cannot load email detail", "danger");
                })

                // this.modals.iframeEl.style.height = 350 + 'px';
                // var doc=this.modals.iframeEl.contentWindow.document;                
                // doc.open();
                // doc.write(this.selectedEmail.body!=null?this.selectedEmail.body:"");
                // doc.close();
                

                //var docPrint=this.modals.iframeElPrint.contentWindow.document;
                //docPrint.open();
                //docPrint.write(this.selectedEmail.body!=null?this.selectedEmail.body:"");
                //docPrint.close();
                // this.modals.iframe.src = 'data:text/html;charset=utf-8,' + encodeURI(this.selectedEmail.body);
                // console.log(this.$refs.iframe_new);




                // if (iframe.contentDocument)
                //     iframedoc = iframe.contentDocument;
                // else if (iframe.contentWindow)
                //     iframedoc = iframe.contentWindow.document;

                // if (iframedoc) {
                //     // Put the content in the iframe
                //     iframedoc.open();
                //     iframedoc.writeln(this.selectedEmail.body);
                //     iframedoc.close();
                // }



                this.modals.viewemail.data.remark=remark;
                this.modals.viewemail.data.files=this.selectedEmail.attachments;
                // modals.viewemail.data.body
            },
            sendEmail(){
                let case_id = this.$route.params.id;
                this.modals.addActivity.loading=true;
                let keyMessage = 'editing';


                let params = Object.assign({
                        caseId: case_id,
                    }, this.modals.addActivity.data);

                if(case_id){

                    this.$store.dispatch(`EmailIntegrationController/sendEmail`, params)
                    .then(response => {

                        this.modals.addActivity.loading = false;
                        this.modals.addActivity.open = false;
                        this.is_outdate = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2(keyMessage, 'activity_log'));
                    })
                    .catch(err => {
                        this.modals.remark.loading = false;
                    })
                }


            },
            addAttachment(){
                if( this.modals.attachment.filename == 'Click Browse to upload file' && !this.modals.attachment.fileAttachment ) {
                    return this.$alertNotification("Please select a file", "danger");
                }

                if(this.modals.attachment.index !== '') {
                    if(this.modals.attachment.id != 0) {
                        if(this.modals.remark.attachments[this.modals.attachment.index]) {
                            this.modals.remark.attachments[this.modals.attachment.index].image_file_title = this.modals.attachment.image_file_title
                            this.modals.remark.attachments[this.modals.attachment.index].image_file_name = this.modals.attachment.fileAttachment ? this.modals.attachment.fileAttachment.name : this.modals.remark.attachments[this.modals.attachment.index].image_file_name
                            let index = this.modals.remark.attachment_tmp.update.findIndex(item => item.id == this.modals.attachment.id)
                            if(index != -1) {
                                this.modals.remark.attachment_tmp.update[index] = Object.assign(this.modals.remark.attachment_tmp.update[index], {
                                    image_file_title: this.modals.attachment.image_file_title,
                                    attachment: this.modals.attachment.fileAttachment || this.modals.remark.attachment_tmp.update[index].attachment
                                })
                            } else {
                                this.modals.remark.attachment_tmp.update.push({
                                    id: this.modals.attachment.id,
                                    image_file_title: this.modals.attachment.image_file_title,
                                    attachment: this.modals.attachment.fileAttachment
                                })
                            }
                        }
                    } else {
                        let idx = this.modals.attachment.index.slice(3);
                        if(this.modals.remark.attachment_tmp.add[idx]) {
                            this.modals.remark.attachment_tmp.add[idx] = this.modals.remark.attachment_tmp.add[idx] || this.modals.attachment.fileAttachment;
                            this.modals.remark.attachment_tmp.add[idx].image_file_title = this.modals.attachment.image_file_title
                        }
                    }
                    this.$refs['modal-Import-attachments-edit'].hide();
                } else {
                    //Add attachment
                    this.modals.attachment.fileAttachment.image_file_title = this.modals.attachment.image_file_title;
                    this.modals.remark.attachment_tmp.add.push(this.modals.attachment.fileAttachment);
                }
                this.resetFormImport();
                this.modals.attachment.open = false;
            },
            openModalupdateAttachment(index, item) {
                this.modals.attachment.image_file_title = item.image_file_title;
                this.modals.attachment.filename = item.image_file_name || item.name;
                this.modals.attachment.id = item.id || 0;
                this.modals.attachment.index = index;
                this.$refs['modal-Import-attachments-edit'].show();
            },
            resetFormImport() {
                this.modals.attachment.filename = 'Click Browse to upload file';
                this.modals.attachment.fileAttachment = null;
                this.modals.attachment.image_file_title = null;
                this.modals.attachment.id = 0;
                this.modals.attachment.index = '';
            },
            /*renameField() {
                if(this.isCaseActivity) {
                    this.tableConfig.fields.forEach(item => {
                        if( item.key === 'created_at' ) {
                            item.label = 'Date & Time';
                        }
                        if (item.key === 'action') {
                            item.label = 'Action';
                        }
                    })
                }
            },*/
            addActivityLog(){
                // this.modals.remark.data = {
                //         id:null,
                //         remark: null,
                //         time_stamp:null,
                //         log_type:'Manual',
                //         actor:null,
                //         actor_id:null,
                //         attachments: [],
                //         attachmentUpdate: [],
                //         attachmentDeleteId: [],
                //         attachment_tmp: {
                //             delete: [],
                //             add:[],
                //             update: []
                //         },
                //         action:null,
                //         time:moment(new Date()).format("HH:mm"),
                //         date:new Date()
                // };
                // this.modals.remark.attachments = [];
                // this.modals.remark.attachmentUpdate = [];
                // this.modals.remark.attachmentDeleteId = [];
                // this.modals.remark.attachment_tmp = {
                //         delete: [],
                //         add:[],
                //         update: []
                // };
                // this.officerName = null
                // this.modals.remark.button_label = 'SAVE';
                // this.modals.remark.title = 'Create Activity Log';
                // this.modals.remark.open = true;
                if(this.Item.status == 'Closed') this.showModalAddNote()
                else this.modals.escalation.open = true;
            },
            /*checkShowIcon(val) {
                if(!val) return false;
                let arrTemp = val.split('/');
                if(!arrTemp || arrTemp.length < 2 || !this.icons[arrTemp[0]]) return false;
                return true;
            },*/
            addEmailActivityLog(){

                this.modals.addActivity.data.to=null;
                this.modals.addActivity.data.cc=null;
                this.modals.addActivity.data.subject=null;
                this.modals.addActivity.data.body="<h1> </h1>";
                this.modals.addActivity.data.remark=null;
                this.modals.addActivity.data.files=null;
                this.modals.addActivity.open = true;
            },
            /* ----Save data ----------------------------------------------------*/
            saveActivity(is_close_case = false){
                if(!this.modals.remark.data.date ||
                    !this.modals.remark.data.time ||
                    !this.officerName ||
                    !this.modals.remark.data.action ||
                    !this.modals.remark.data.remark){
                    return this.$alertNotification('Please enter all fields!', 'danger');
                }
                // var getActivityLog = null;
                // if(this.tableItems.length > 0){
                //     getActivityLog = Object.assign([], this.tableItems);
                //     let act = this.modals.remark.data.action.reference_value_text;
                //     let filterAc = getActivityLog.filter(function(val){
                //         return val.action == act && !val.deleted_at && val.status != 'OutDated';
                //     });
                //     if(filterAc.length > 0){
                //         if(!this.modals.remark.data.id){
                //             return this.$alertNotification('Please use another action!', 'danger');
                //         }
                //     }

                // }

                if(this.modals.remark.is_allow_change_status) {
                    this.modals.remark.loading_save_status = true
                } else {
                    this.modals.remark.loading = true;
                }
                if(is_close_case &&
                    this.modals.remark.is_allow_change_status &&
                    this.modals.remark.data.action &&
                    this.modals.remark.data.action.reference_value_abbr &&
                    this.modals.remark.data.action.reference_value_abbr == 'nlt-close-a-case'
                ){
                    this.modals.remark.open = false;
                    this.modals.closeCase.open = true;
                    return;
                }
                let params = {};

                let action = "createLogCase"
                let keyMessage= 'adding'
                this.modals.remark.data.attachments = this.modals.remark.attachment_tmp.add;
                this.modals.remark.data.attachmentUpdate = this.modals.remark.attachment_tmp.update;
                this.modals.remark.data.attachmentsDelete = this.modals.remark.attachment_tmp.delete;
                if(this.officerName){
                    this.modals.remark.data.actor_id = this.officerName.user_id;
                    this.modals.remark.data.actor = this.officerName.user_name;
                }
                if(this.modals.remark.data.id){
                    action = "createLogCaseWithOutDated"
                    keyMessage = 'editing'
                    params = Object.assign({
                        work_item_type: this.activityType,
                        work_item_id: this.activityId,
                    }, this.modals.remark.data);
                    params.time_stamp = moment(params.date).format("YYYY-MM-DD") + ' ' + params.time;
                    delete params['date'];
                    delete params['time'];
                }else{
                    params = Object.assign({
                        work_item_type: this.activityType,
                        work_item_id: this.activityId,
                    }, this.modals.remark.data);
                    params.time_stamp = moment(params.date).format("YYYY-MM-DD") + ' ' + params.time;
                    delete params['date'];
                    delete params['time'];
                }
                params.action = this.modals.remark.data.action.reference_value_text;
                params.nlt_case_key_action = this.modals.remark.data.action.reference_value_abbr ? this.modals.remark.data.action.reference_value_abbr : null
                params.is_allow_change_status = this.modals.remark.is_allow_change_status
                this.$store.dispatch(`ActivityLogsController/${action}`, params)
                    .then(response => {
                        this.modals.remark.loading_save_status = false
                        this.modals.remark.loading = false;
                        this.modals.remark.open = false;
                        this.modals.closeCase.open = false;
                        this.is_outdate = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2(keyMessage, 'activity_log'));
                        this.$emit('loadCase')
                    })
                    .catch(err => {
                        this.modals.remark.loading_save_status = false
                        this.modals.remark.loading = false;
                        if(err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                            this.$alertNotification(err.response.data.error.message, "warning");
                        }
                    })
            },
            async clickToRowItem(item){
                if(!this.controls.update) return;
                this.modals.remark.attachments = [];
                this.modals.remark.attachmentUpdate =  [];
                this.modals.remark.attachmentUpdate = [];
                this.modals.remark.attachment_tmp = {
                    delete: [],
                    add:[],
                    update: []
                };
                this.is_outdate = true;
                this.modals.remark.is_allow_change_status = false;
                if(!item.status && !item.deleted_at && !this.checkIsJson(item.remark)){
                    // this.modals.remark.button_label = 'UPDATE';
                    this.modals.remark.title = 'Edit Activity Log';
                    this.modals.remark.data.id = item.id;
                    this.modals.remark.data.time_stamp = item.time_stamp;
                    this.modals.remark.data.date = null;
                    this.modals.remark.data.time = null;
                    if(item.time_stamp){

                        this.modals.remark.data.date = new Date(moment(item.time_stamp).format("YYYY-MM-DD"));
                        this.modals.remark.data.time = moment(item.time_stamp).format("HH:mm");
                    }
                    if(item.attachments.length > 0){
                        this.modals.remark.attachments = JSON.parse(JSON.stringify(item.attachments));
                    }
                    let offName = this.fmOfficer.filter(val => val.user_id === item.actor_id);
                    if(offName.length > 0){
                        this.officerName = offName[0];
                    }
                    let action = {
                        reference_value_text: item.action,
                        reference_value_abbr: item.nlt_case_key_action
                    };
                    this.modals.remark.data.action = action;
                    this.modals.remark.data.log_type = item.log_type;
                    //this.modals.remark.data.action = item.action;
                    this.modals.remark.data.actor = item.actor;
                    this.modals.remark.data.remark = item.remark;
                    this.modals.remark.open = true;
                }
            },
            /* ---- Get data ----------------------------------------------------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.work_item_id.value = this.activityId;
                tableRequest.filter.work_item_type.value = this.activityType;
                if(this.isFilterDrp){
                    tableRequest.type_filter = this.isFilterDrp;
                }

                //tableRequest.filter.log_type.value = 'Manual';
                await this.$store.dispatch("ActivityLogsController/getActivityLogCase", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('ActivityLogsController/deleteCaseLog', ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'activity_log'))
                    })
                    .catch(err => {
                        reject();
                    })
            },
            async replyItem(callback)
            {
                const { ids,filter, resolve,reject } = await callback();
                let itemSelected = this.tableItems.filter(item => item.id == ids);
                
                const check_latest=await this.checkLatestEmail(itemSelected[0].email_id);
                this.modals.replyingToConfirm.from = itemSelected[0].email.from;
                let email_from = itemSelected[0].email.from;

                var arrCheck = ['cstl.stg@emservices.com.sg',
                                        'qp.stg@emservices.com.sg',
                                        'ask.stg@emservices.com.sg',
                                        'cstl@netlinknbn.com',
                                        'qpmail@netlinknbn.com',
                                        'ask@netlinknbn.com',
                                        'no-reply-staging-fm@gofix.com.sg',
                                        'no-reply-dev@gofix.com.sg',
                                        'no-reply-nlt@gofix.com.sg'];

                var fromCheck = false;

                for(var i=0;i<arrCheck.length;i++){
                    if(email_from.toLowerCase().includes(arrCheck[i])){
                        fromCheck = true;
                        break;
                    }
                }

                if(fromCheck)
                {
                    this.modals.replyingToConfirm.from = itemSelected[0].email.to;
                }
                 

                if(check_latest)
                {
                    this.modals.reply.email=itemSelected[0].email;
                    this.modals.replyingToConfirm.open = true;                   
                }else
                {
                    this.modals.reply.email=itemSelected[0].email;
                    this.modals.latestEmail.open=true;
                }


            },
            async replyItemFromViewEmail()
            {
                this.modals.viewemail.open=false;
                var ids = this.modals.viewemail.data.activity_id;
                
                let itemSelected = this.tableItems.filter(item => item.id == ids);
                
                const check_latest=await this.checkLatestEmail(itemSelected[0].email_id);
                this.modals.replyingToConfirm.from = itemSelected[0].email.from;
                let email_from = itemSelected[0].email.from;

                var arrCheck = ['cstl.stg@emservices.com.sg',
                                        'qp.stg@emservices.com.sg',
                                        'ask.stg@emservices.com.sg',
                                        'cstl@netlinknbn.com',
                                        'qpmail@netlinknbn.com',
                                        'ask@netlinknbn.com',
                                        'no-reply-staging-fm@gofix.com.sg',
                                        'no-reply-dev@gofix.com.sg',
                                        'no-reply-nlt@gofix.com.sg'];

                var fromCheck = false;

                for(var i=0;i<arrCheck.length;i++){
                    if(email_from.toLowerCase().includes(arrCheck[i])){
                        fromCheck = true;
                        break;
                    }
                }

                if(fromCheck)
                {
                    this.modals.replyingToConfirm.from = itemSelected[0].email.to;
                }
                    

                if(check_latest)
                {
                    this.modals.reply.email=itemSelected[0].email;
                    this.modals.replyingToConfirm.open = true;                     
                }else
                {
                    this.modals.reply.email=itemSelected[0].email;
                    this.modals.latestEmail.open=true;
                }
                

            },
            async checkLatestEmail(email_id)
            {
                return new Promise((resolve, reject) => {

                    this.$store.dispatch('EmailIntegrationController/checkLatestEmail', {
                    email_id: email_id                
                    })
                    .then(response => {
                        resolve(response.data.data);
                    }).catch(err => {
                        this.$alertNotification("Cannot verify if this email is latest", "danger");
                        console.log(err);
                        reject( err );

                    })
                });
              

                
            },
            latestEmailConfirm()
            {
                this.modals.replyingToConfirm.open=true;
                this.modals.latestEmail.open=false;

            },
            latestEmailCancel()
            {
                this.modals.latestEmail.open = false;
                this.$refs.gofixTable.uncheckedRow();

            },

            replyingToConfirmBtnClick()
            {
                this.modals.reply.open=true;
                this.modals.replyingToConfirm.open=false;

            },
            replyingToCancelBtnClick()
            {
                this.modals.replyingToConfirm.open=false;
                this.$refs.gofixTable.uncheckedRow();

            },

            triggerReloadData(){
                this.$refs.gofixTable.reloadTableItems();
            },

            /* ---- Attributes ----------------------------------------------------*/
            hiddenModalRemark(){
                this.modals.remark.data.id = null;
                this.modals.remark.data.remark = null;
                this.modals.remark.title = 'Add Remark';
                this.modals.addActivity.data.from = null;
                this.modals.addActivity.emailTemplate = null;
            },
            checkIsJson(item){
                if(!item) return false;
                if(!isNaN(item)) return false;
                try {
                    let json_ = JSON.parse(item);
                    
                    if ( typeof(json_) == 'string' ) {
                        return false;
                    } else {
                        return true;
                    }
                } catch (e) {
                    return false;
                }
                return true;
            },
            changeSelectedTable(val) {
                this.modals.ids = val;
            },
            refreshData() {
                this.getCaseEdit();
                this.$refs.gofixTable.reloadTableItems();
                this.$emit('loadCase')
            },
            exportNLT() {
                this.$refs.gofixTable.actionStatus.listLoading = true;
                this.$store.dispatch('ActivityLogsController/exportActivityNLT', {
                    case_id: this.$route.params.id,
                    type: this.isFilterDrp
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'ActivityLog.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.$refs.gofixTable.actionStatus.listLoading = false;
                }).catch(err => {
                    this.$refs.gofixTable.actionStatus.listLoading = false;
                })
            },
            print(){
                const that = this;
                this.modals.printPDF.process = 0;
                this.modals.printPDF.open = false;
                this.modals.printPDF.process = "Printing PDF";
                this.modals.printPDF.open_process = true;

                var elementHeader = document.getElementById('emailHeaders');
                var eleHdClone= elementHeader.cloneNode(true);
                var docPrint=this.modals.iframeElPrint.contentWindow.document;
                docPrint.open();
                docPrint.write(eleHdClone.innerHTML+(this.selectedEmail.body!=null?this.selectedEmail.body:""));
                docPrint.close();

                var elementIframe = document.getElementById('iframePrint').contentWindow.document.body;

                let case_id = this.$route.params.id;
                var pdf_file_name = case_id + '_' + this.selectedEmail.id + '_email_print.pdf';
            
                this.modals.printPDF.process = "Printing";
                const opt = {
                    margin: 0.1,
                    filename: pdf_file_name,
                    image: { type: "jpeg", quality: 1 },
                    html2canvas: {
                        scale: 2,
                        logging: true,
                        letterRendering: true,
                        useCORS: true,
                        onclone: function (doc) {
                        },
                        windowWidth: elementIframe.scrollWidth,
                        windowHeight: elementIframe.scrollHeight,
                        x:0,
                        y:0
                    },
                    jsPDF: {
                        unit: "in",
                        format: "A4",
                        orientation: "portrait",
                    },
                };
                html2pdf()
                .set(opt)
                .from(elementIframe.innerHTML)
                .toPdf()
                .save().then(
                    function (pdf) {
                        that.modals.printPDF.open_process = false;   
                    }, 
                    function(){
                        //Error Here 
                    }
                );
                    
            },
            printNative(){
                const that = this;
                this.modals.printPDF.process = 0;
                this.modals.printPDF.open = false;
                this.modals.printPDF.process = "Printing PDF";
                this.modals.printPDF.open_process = true;

                var windowTitle = document.title;
                var subjectFileName = this.selectedEmail.subject.replace(/[/\\?%*:|"<>]/g, '-');
                if (subjectFileName.length > 200) subjectFileName = subjectFileName.substring(0,200);
                var elementHeader = document.getElementById('emailHeaders');
                var eleHdClone= elementHeader.cloneNode(true);
                var docPrint=this.modals.iframeElPrint.contentWindow.document;
                docPrint.open();
                docPrint.title = subjectFileName;
                docPrint.write(eleHdClone.innerHTML+(this.selectedEmail.body!=null?this.selectedEmail.body:""));
                docPrint.write("<style>\
                .gofixTextField .labelTitle{margin-bottom:6px}.gofixTextField .value{font-size:16px;color:#000;word-break:break-word;position:relative;width: 100%;}.gofixTextField.gofixTextFieldOneLine .inner{display:flex;line-height:1.2}.gofixTextField.gofixTextFieldOneLine .value{padding-left:15px}.gofixTextField.gofixTextFieldValueSmall .value{font-size:14px}.gofixTextField.gofixTextFieldInputStyle{background:hsla(0,0%,60%,.05);padding:22px 0 0}.gofixTextField.gofixTextFieldInputStyle .label{padding-left:16px;position:absolute;left:0;font-size:12px;top:8px;pointer-events:none;transition:all .3s;color:rgba(0,0,0,.6);text-transform:capitalize;white-space:nowrap;text-overflow:ellipsis;max-width:100%;overflow:hidden}.gofixTextField.gofixTextFieldInputStyle .value{padding:0 0 0 16px;font-size:14px;color:#000;line-height:34px}\
                .gofixTextFieldViewEmail{background-color:hsla(0,0%,60%,.05);margin-bottom:15px}.gofixTextFieldViewEmail .labelTitle .label{font-size:12px}.gofixTextFieldViewEmail .textValue{border-bottom:2px solid rgba(0,0,0,.38)}.gofixTextFieldViewEmail .textValue span{font-size:14px}\
                .gofixInput{position:relative;width:100%;margin-bottom:26px}\
                #emailHeaders div{display:block;width:100%}\
                </style>");
                docPrint.write("<style media=\"print\">\
                @page {size: auto;margin: 0mm;}\
                html {background-color: #FFFFFF;margin: 0px;}\
                body {margin: 5mm 7mm 5mm 7mm;-webkit-print-color-adjust: exact;-moz-print-color-adjust: exact;-ms-print-color-adjust: exact;print-color-adjust: exact;}\
                </style>");
                docPrint.close();

                document.title = subjectFileName;
                document.getElementById("iframePrint").contentWindow.print();
                document.title = windowTitle;
                this.modals.printPDF.open_process = false;
                return;
            },
            async downloadEML(){
                let case_id = this.$route.params.id;
            
                if(this.selectedEmail.s3_eml_url){
                    let url = this.selectedEmail.s3_eml_url;
                    let params = {};
                    params.url = url;
                    var subjectFileName = this.selectedEmail.subject.replace(/[/\\?%*:|"<>]/g, '-');
                    if (subjectFileName.length > 200) subjectFileName = subjectFileName.substring(0,200);
                    params.image_file_name = subjectFileName + '.eml';

                    await this.$store.dispatch("FileDownloadController/getFile", params)
                    .then(response => {
                    })
                    .catch(err => {
                        this.$alertNotification("Can not download file", "danger");
                        console.log(err);
                    });
                }
                else {
                    alert('EML file not found.');
                }                    
            },
          async getEmailTemplates(){
            await this.$store.dispatch("NotificationTemplateController/getItems", {
              page:1,
              limit:-1,
              filter:{
                contract_id: this.Item.contract ? this.Item.contract.id : 0,
              },
              caseID: this.Item ? this.Item.id : 0,
              decode: true
            }).then(response => {
              this.modals.addActivity.emailTemplates = response.data.data.items
            })
                .catch(err => {
                  this.modals.addActivity.emailTemplates=[]
                })
          },
            iframeNewLoaded(){
                if(this.modals.iframeEl && this.modals.iframeEl.contentWindow){
                    var iframe=this.modals.iframeEl;
                    var modalBody = this.$el.querySelectorAll(`#modal-ViewEmail___BV_modal_body_`)[0];
                    setTimeout(() => this.iframeNewLoadedDelay(iframe,modalBody), 1000);
                }
                
            },
            iframeNewLoadedDelay(iframe,modalBody){
                    var sHeight = iframe.contentWindow.document.body.scrollHeight;
                    var buffer = 0;
                    if(sHeight<1000){
                        buffer=30;
                    }
                    else if (sHeight<10000){
                        buffer=50;
                    }
                    else {
                        buffer =sHeight/100;
                    }
                    var finalHeight = sHeight + buffer;  
                    if(finalHeight<350){
                        finalHeight=350;
                    }
                    iframe.style.height = finalHeight + 'px';
                    modalBody.scrollTop =0;
            },
            /* -- Allow to add note and upload attachment in activity log after the case is closed -- */
            showModalAddNote() {
                this.disabledWithAddNote = true
                this.tableConfig.controls.update = true
                this.modals.remark.title = 'Create Activity Log'
                this.officerName = { user_id: this.UserLogin.id, user_name: this.UserLogin.name, user_email: this.UserLogin.email }
                this.modals.remark.data.action = { reference_value_text: "Add note", reference_value_abbr: "nlt-add-note" };
                if(this.actionType.length) {
                    let arrTmp = this.actionType.filter(item => item.reference_value_abbr == 'nlt-add-note')
                    if(arrTmp.length) this.modals.remark.data.action = arrTmp[0]
                }
                this.modals.remark.attachments = [];
                this.modals.remark.attachmentUpdate =  [];
                this.modals.remark.attachmentUpdate = [];
                this.modals.remark.attachment_tmp = { delete: [], add:[], update: [] };
                this.modals.remark.is_allow_change_status = false;
                this.modals.remark.data.id = null;
                this.modals.remark.data.time_stamp = null;
                this.modals.remark.data.date = moment().toDate();
                this.modals.remark.data.time = moment().format("HH:mm");
                this.modals.remark.data.log_type = "Manual";
                this.modals.remark.data.remark = null;
                this.modals.remark.open = true;
                //actionType
            },
            selectableAction(item) {
                if(this.modals.remark.data.id) {
                    return this.$checkRole(this.$accessModule.amend_closed_case_activity, 'amend_closed_case_activity')
                }
                if(this.Item.status == 'Closed' && item.reference_value_abbr != 'nlt-add-note') return false
                return true
            },
            resetModalRemark() {
                this.modals.remark.attachmentDeleteId = []
                if(this.disabledWithAddNote) {
                    this.disabledWithAddNote = false
                    this.tableConfig.controls.update = this.$checkRole(this.$accessModule.amend_closed_case_activity, 'amend_closed_case_activity')
                }
                
            },
            async resendEmail(callback)
            {
                const { ids,filter, resolve,reject } =  await callback();
                let SelectedItem = this.tableItems.find(element => ids == element.id);
                if(SelectedItem.email && SelectedItem.email.status !== null && SelectedItem.email.status == 'failed'){
                    

                      let params = Object.assign({
                        email_ids: SelectedItem.email_id
                    });

                    this.$store.dispatch("EmailIntegrationController/resendEmail", params)
                        .then(response => {
                            return this.$alertNotification("This email has been resent. Please reload the activity list after few minutes.");
                        })
                        .catch(err => {
                            return this.$alertNotification("Error has occured", "danger");
                        })

                    
                }else 
                {
                    return this.$alertNotification("Sorry, this email cannot resend, it was not failed status.", "danger");

                }
            },
        }
    }
</script>
